(ns manage.content-variant-page.queries
  (:require [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.db.effects.binary :as binary]
            [common.queries :as queries :refer [invalidate-queries]]
            [common.queries.http :as qhttp]
            [common.queries.muix-filter-util :as filter-util]
            [promesa.core :as p]
            [re-frame.core :as rf]))

(def active-fetch-interval 1000)

(def refetch-import-status
  (queries/make-refetch-interval-fn
   {:interval-fn (fn [query fetch-count]
                   (let [current-import-state (some-> (.-data (.-state query)) .-data .-state)
                         ;; If import is "running", keep fetching every 1000ms,
                         ;; else try 6 retries with increasing interval starting
                         ;; from page load or invalidation to see if the
                         ;; status goes to "running" (which it goes after re-import).
                         ;; NOTE: If the import is really fast, we might
                         ;; just see "completed" -> "completed", but import-id changing.
                         ;; We could also stop when the import-id changes.
                         is-feed-import-running? (= "running" current-import-state)
                         interval (if is-feed-import-running?
                                    active-fetch-interval
                                    (if (< fetch-count queries/max-fetches)
                                      (* (queries/sigmoid fetch-count) queries/max-fetch-interval)
                                      0))]
                     interval))}))

(defn latest-feed-import-status-query [advertiser-id feed-id]
  #js {:queryKey #js ["latest-feed-import-status-query" feed-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/content-build-feed-latest-import {:advertiser-id advertiser-id
                                                                                  :feed-importer-id feed-id})))
       :refetchInterval refetch-import-status
       :enabled (some? feed-id)})

(defn latest-feed-import-errors-query [advertiser-id feed-id import-id is-feed-import-running?]
  #js {:queryKey #js ["latest-feed-import-errors-query" advertiser-id import-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/content-build-feed-latest-import-errors-aggregated
                                           {:advertiser-id advertiser-id
                                            :feed-importer-id feed-id
                                            :import-id import-id})))
       :enabled (and (some? feed-id)
                     (some? import-id)
                     (not is-feed-import-running?))})

;; NOTE: The following are now just for ad-variants creation content tab
;; Maybe add these elsewhere, but these are similar to the previous two
;; and might be later also used in the ad-variant content tab?

;; :resource.feed-importers/trigger
(defn trigger-feed-import-mutation [{:keys [advertiser-id adset-id]} feed-id]
  #js {:mutationKey #js ["trigger-feed-import" advertiser-id feed-id]
       :mutationFn (fn [{:keys [trigger-ad-variants?]
                         :or {trigger-ad-variants? false}}]
                     (qhttp/post (qhttp/render :api/feed-importer-trigger {:advertiser-id advertiser-id
                                                                           :feed-importer-id feed-id}
                                               {:trigger-ad-variants trigger-ad-variants?})))
       :onSuccess (fn [_resp {:keys [trigger-ad-variants?]}]
                    (queries/invalidate-queries {:queryKey ["latest-feed-import-status-query" feed-id]})
                    (when trigger-ad-variants?
                      (queries/invalidate-queries {:queryKey ["adset-content-build" advertiser-id adset-id]})))})

;; :resource.feed-importers/get-one
(defn get-feed [advertiser-id feed-id]
  #js {:queryKey #js ["feed-importer" advertiser-id feed-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/feed-importer {:advertiser-id advertiser-id
                                                               :feed-importer-id feed-id})))
       :enabled (some? feed-id)})

;; :resource.feed-importers/get-content-feed
(defn get-content-feed [advertiser-id feed-id]
  #js {:queryKey #js ["content-build-feed" advertiser-id feed-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/content-build-feed {:advertiser-id advertiser-id
                                                                    :feed-importer-id feed-id})))
       :enabled (and (some? advertiser-id) (some? feed-id))})

;; :resource.feed-importers/get-fields
(defn get-fields [advertiser-id feed-id]
  #js {:queryKey #js ["feed-importer-fields" advertiser-id feed-id]
       :retry queries/prevent-client-error-retries
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/feed-importer-fields {:advertiser-id advertiser-id
                                                                      :feed-importer-id feed-id})))
       :enabled (and (some? advertiser-id) (some? feed-id))})

;; :resource.content-variants/fetch-all
(defn get-content-variants
  [advertiser-id feed-id
   {:keys [default-sorting] :as filter-params
    :or {default-sorting {:field "sequence-number" :sort "asc"}}}
   {:keys [^js sort-model ^js filter-model] :as table-models}]
  #js {:queryKey #js ["content-build-variants" advertiser-id feed-id sort-model filter-model]
       :queryFn (fn [^js ctx]
                  (let [filter-params (assoc filter-params :default-sorting default-sorting)
                        {:keys [muix-data-grid] :as query-params}
                        (filter-util/get-query-params filter-params table-models ctx)]
                    (qhttp/post (qhttp/render :api/content-build-variants
                                              {:advertiser-id advertiser-id
                                               :feed-importer-id feed-id}
                                              (dissoc query-params :muix-data-grid))
                                {:body {:muix-data-grid muix-data-grid}})))
       :enabled (some? feed-id)
       :getNextPageParam filter-util/default-get-next-page-param})

(defn submit-feed-mapping-mutation [{:keys [advertiser-id feed-id adset-id]}]
  #js {:mutationKey #js ["submit-feed-mapping-mutation" advertiser-id feed-id adset-id]
       :mutationFn
       (fn [{:keys [field-mappings field-classes field-content-mappings ad-formats-payload allow-owerriding]}]
         (p/let [feed-importer-response (qhttp/patch (qhttp/render :api/feed-importer {:advertiser-id advertiser-id
                                                                                       :feed-importer-id feed-id})
                                                     {:body {:mappings field-mappings}})
                 field-classes-response (qhttp/put (qhttp/render :api/content-build-field-classes
                                                                 {:advertiser-id advertiser-id
                                                                  :feed-importer-id feed-id}
                                                                 {:allow-overwriting allow-owerriding})
                                                   {:body field-classes})
                 content-mapping-response (qhttp/put (qhttp/render :api/content-build-field-content-mappings
                                                                   {:advertiser-id advertiser-id
                                                                    :feed-importer-id feed-id}
                                                                   {:allow-overwriting allow-owerriding})
                                                     {:body field-content-mappings})
                 ad-format-response (when (seq ad-formats-payload)
                                      (qhttp/put (qhttp/render :api/adset-ad-formats {:adset-id adset-id})
                                                 {:body ad-formats-payload}))]
           [feed-importer-response field-classes-response content-mapping-response ad-format-response]))
       :onSuccess (fn [_ _ _context]
                    (invalidate-queries {:queryKey ["ad-builders-upgrade-hints" adset-id]})
                    (invalidate-queries {:queryKey ["content-build-feed" advertiser-id feed-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:entity-name "feed-mapping"
                                   :type :success
                                   :message "Successfully saved mapping"}]))
       :onError (fn [_ _ _context]
                  (rf/dispatch [:response-handler/handle-response {:entity-name "feed-mapping"
                                                                   :type :error
                                                                   :message "Failed to save mapping"}]))})

(defn download-content-variants [advertiser-id feed-id]
  #js {:mutationKey #js ["download-content-variants" advertiser-id feed-id]
       :mutationFn (fn [{:keys [format]}]
                     (qhttp/get (qhttp/render :api/content-build-variants-download
                                              {:advertiser-id advertiser-id
                                               :feed-importer-id feed-id}
                                              {:format format})
                                {:response-format :binary+filename}))
       :onSuccess (fn [{:keys [blob filename]}]
                    (binary/download blob filename))})

(defn inline-editing-transactions [advertiser-id feed-id]
  #js {:queryKey #js ["inline-editing-transactions" advertiser-id feed-id]
       :queryFn (fn []
                  (qhttp/get (qhttp/render :api/content-build-feed-inline-editing-transactions
                                           {:advertiser-id advertiser-id
                                            :feed-importer-id feed-id})))
       :enabled (some? feed-id)})

(defn inline-editing-mutation [advertiser-id feed-id]
  #js {:mutationKey #js ["put-inline-editing" advertiser-id feed-id]
       :mutationFn (fn [params]
                     (qhttp/put (qhttp/render :api/content-build-feed-inline-editing
                                              {:advertiser-id advertiser-id
                                               :feed-importer-id feed-id})
                                {:body params}))
       :onSuccess (fn [response]
                    (let [{:keys [changed-rows-count deleted-rows-count added-rows-count]} (->clj response)
                          action-message (fn [count action]
                                           (str count
                                                (if (= 1 count) " variant was " " variants were ")
                                                action))
                          messages (cond-> []
                                     (pos? added-rows-count) (conj (action-message added-rows-count "added"))
                                     (pos? changed-rows-count) (conj (action-message changed-rows-count "changed"))
                                     (pos? deleted-rows-count) (conj (action-message deleted-rows-count "deleted")))]
                      (if (seq messages)
                        (rf/dispatch [:toaster-bus/add {:type :success
                                                        :message (str/join ", " messages)}])
                        (rf/dispatch [:toaster-bus/add {:type :error
                                                        :message "Failed to make inline edits"}]))
                      (queries/invalidate-queries {:queryKey ["get-inline-editing-lock" advertiser-id feed-id]})
                      (queries/invalidate-queries {:queryKey ["inline-editing-transactions" advertiser-id feed-id]})
                      (queries/invalidate-queries {:queryKey ["content-build-variants" advertiser-id feed-id]})))
       :onError (fn []
                  (rf/dispatch [:toaster-bus/add {:type :error
                                                  :message "Failed to make inline edits"}]))})

(defn inline-editing-lock-query [advertiser-id feed-id]
  #js {:queryKey #js ["get-inline-editing-lock" advertiser-id feed-id]
       :enabled (some? feed-id)
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/content-build-feed-inline-editing-lock
                                           {:advertiser-id advertiser-id
                                            :feed-importer-id feed-id})))})

(defn put-inline-editing-lock-mutation [advertiser-id feed-id]
  #js {:mutationKey #js ["put-inline-editing-lock" advertiser-id feed-id]
       :mutationFn (fn [_variables]
                     (qhttp/put (qhttp/render :api/content-build-feed-inline-editing-lock
                                              {:advertiser-id advertiser-id
                                               :feed-importer-id feed-id})))
       :onSuccess (fn [_response]
                    (queries/invalidate-queries {:queryKey ["get-inline-editing-lock" advertiser-id feed-id]}))
       :onError (fn [_response]
                  (queries/invalidate-queries {:queryKey ["get-inline-editing-lock" advertiser-id feed-id]}))})

(defn delete-inline-editing-lock-mutation [advertiser-id feed-id]
  #js {:mutationKey #js ["delete-inline-editing-lock" advertiser-id feed-id]
       :mutationFn (fn [_variables]
                     (qhttp/delete (qhttp/render :api/content-build-feed-inline-editing-lock
                                                 {:advertiser-id advertiser-id
                                                  :feed-importer-id feed-id})))
       :onSuccess (fn [_response]
                    (queries/invalidate-queries {:queryKey ["get-inline-editing-lock" advertiser-id feed-id]}))})

(defn update-field-classes-mutation [advertiser-id feed-id]
  #js {:mutationKey #js ["update-field-classes" advertiser-id feed-id]
       :mutationFn (fn [field-classes-payload]
                     (qhttp/put (qhttp/render :api/content-build-field-classes
                                              {:advertiser-id advertiser-id
                                               :feed-importer-id feed-id}
                                              {:allow-overwriting true})
                                {:body field-classes-payload}))
       :onMutate (fn [] (rf/dispatch [:loader/open]))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [_ _ _context]
                    (invalidate-queries
                     {:queryKey ["content-build-feed" advertiser-id feed-id]}))
       :onError (fn [error _ _context]
                  (rf/dispatch [:response-handler/handle-response
                                {:type :error
                                 :message "Failed to update column classifications"
                                 :response error}]))})

(defn update-field-formats-mutation [advertiser-id feed-id]
  #js {:mutationKey #js ["update-field-formats" advertiser-id feed-id]
       :mutationFn (fn [field-formats-payload]
                     (qhttp/put (qhttp/render :api/content-build-field-formats
                                              {:advertiser-id advertiser-id
                                               :feed-importer-id feed-id})
                                {:body field-formats-payload}))
       :onMutate (fn [] (rf/dispatch [:loader/open]))
       :onSettled (fn [] (rf/dispatch [:loader/close]))
       :onSuccess (fn [_ _ _context]
                    (invalidate-queries
                     {:queryKey ["content-build-feed" advertiser-id feed-id]}))
       :onError (fn [error _ _context]
                  (rf/dispatch [:response-handler/handle-response
                                {:entity-name "field-formats"
                                 :type :error
                                 :message "Failed to update column formats"
                                 :response error}]))})

(defn content-build-unique-values-query
  [{:keys [advertiser-id feed-importer-id column-name] :as path-params}]
  #js {:queryKey #js ["content-build-unique-values"
                      advertiser-id feed-importer-id column-name]
       :enabled (and (some? advertiser-id)
                     (some? feed-importer-id)
                     (not (str/blank? column-name)))
       :staleTime (* 60 1000)
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :api/content-build-unique-values path-params)))})
